export default __webpack_public_path__ + "343048540cff3875a281996fffa18c63.png";